import React from 'react';
import './Chatsection.scss';
import {chats} from '../../assets/constants/chats';
import {Link } from 'react-router-dom';
const Chatsection = () => {
    return (
        <div className="chat-component container">
            <div className="chat-box">
                <a href="/landingpage" className="back"><i className="fas fa-arrow-left"></i></a>
                <div className="chat-list">
                    {
                    chats.map(chat => {
                        return <div className="chat-item">
                            <div className="person-info">
                                <h4>{chat.person}</h4>
                                <span>{chat.createdAt}</span>
                            </div>
                            <p>
                                {chat.title}
                            </p>
                        </div>

                    })
                    }
                </div>
            </div>
        </div>
    );
}

export default Chatsection;
